export class CommandType {
  static DISABLE_PANIC = 'DISABLE_PANIC';
  static BLOCK_VEHICLE = 'SET_OUTPUT_STATUS';
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/command-type.ts